import React from "react"
import { Link } from "react-router-dom"

const CompanySignUpForm = () => {
  return (
    <>
      <div className="SignUp justify-content-center d-flex h-100 align-items-center">
        <div className="row col-xl-6 col-md-8 col-11 pt-5 pb-4 mx-2">
          <form className="p-4 p-md-5 border rounded-3 bg-light">
            <h1 className="display-2 mb-4">Company Sign Up</h1>
            <div className="form-floating mb-3">
              <input
                type="email"
                name="email"
                // value={email}
                className="form-control"
                // onChange={handleOnChange}
              />
              <label className="float-bg" htmlFor="floatingInput">
                Email address
              </label>
            </div>
            <div className="form-floating mb-3">
              <input
                type="text"
                name="username"
                // value={username}
                className="form-control"
                // onChange={handleOnChange}
              />
              <label className="float-bg" htmlFor="floatingInput">
                Username
              </label>
            </div>
            <div className="form-floating mb-3">
              <input
                type="password"
                name="password"
                // value={password}
                className="form-control"
                id="floatingPassword"
                // onChange={handleOnChange}
              />
              <label className="float-bg" htmlFor="floatingPassword">
                Password
              </label>
            </div>
            <div className="form-floating mb-3">
              <input
                type="password"
                name="passwordConfirm"
                // value={passwordConfirm}
                className="form-control"
                id="floatingPasswordConfirm"
                // onChange={handleOnChange}
              />
              <label className="float-bg" htmlFor="floatingPasswordConfirm">
                Confirm Password
              </label>
            </div>
            <button className="w-100 btn btn-lg btn-primary mb-3" type="submit">
              Sign up
            </button>
            <small className="text-muted">
              Already have an account? <Link to="/login">Login</Link>
            </small>
            <hr className="mt-4" />
            <small className="text-muted my-4">
              By clicking Sign up, you agree to the terms of use.
            </small>
          </form>
        </div>
      </div>
    </>
  )
}

export default CompanySignUpForm
